export default __webpack_public_path__ + "static/media/Gida of Pandemonium.1a9f2b69.jpg";